export enum EStatusType {
  Success = 'success',
  Error = 'error'
}
